var proxyTtvBuffer = function (ttvBufferModeResponse) {
    var _a, _b, _c, _d, _e, _f;
    if (ttvBufferModeResponse) {
        var ttv = ttvBufferModeResponse.ttv, buffer = ttvBufferModeResponse.buffer;
        var isTtvRegular = ttv.checkType === 'regular';
        return {
            isTtvOn: ttv && ttv.modeOn,
            ttvUrl: ttv && ttv.url,
            isRegular: isTtvRegular,
            ttvTitle: isTtvRegular ? (_a = ttv.regular) === null || _a === void 0 ? void 0 : _a.title : (_b = ttv.emergency) === null || _b === void 0 ? void 0 : _b.title,
            ttvMessage: isTtvRegular ? (_c = ttv.regular) === null || _c === void 0 ? void 0 : _c.notiMsg : (_d = ttv.emergency) === null || _d === void 0 ? void 0 : _d.notiMsg,
            ttvCheckDate: isTtvRegular ? (_e = ttv.regular) === null || _e === void 0 ? void 0 : _e.checkDate : (_f = ttv.emergency) === null || _f === void 0 ? void 0 : _f.checkDate,
            isBufferOn: buffer && buffer.modeOn,
            bufferUrl: buffer && buffer.url,
        };
    }
    return {
        isTtvOn: false,
        ttvUrl: '',
        isRegular: false,
        ttvTitle: '',
        ttvMessage: '',
        ttvCheckDate: '',
        isBufferOn: false,
        bufferUrl: '',
    };
};
export default proxyTtvBuffer;
